// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)

export class ArchivingErsTMO {
	id?: string = undefined;
	ersIdentifier?: string = undefined;
	serialNumber?: string = undefined;
	businessPremisesId?: string = undefined;
	created?: Date = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)
export class ArchivingErs extends ArchivingErsTMO {
	etag?: string = undefined;
}

// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************


// ENUMS #############################################################
// API enums *********************************************************
// UI enums *********************************************************
